import { React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type SpecificRiskDistributionProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params | DraftParams;
  setParams: (_p: Params) => void;

  fullScreen?: boolean;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'risk_model_specific_risk_distribution', string>;

  title: string;

  context: ts.types.riskModel.RiskModelAnalysisContext;
};

const SpecificRiskDistribution = ({
  id,
  readOnly,
  widgetKey,
  mode,
  params,
  setParams,
  loadWidgetData,
  widgetPaths,
  fullScreen,
  title,
}: SpecificRiskDistributionProps) => {
  const renderJobComponent = () => (
    <Chart
      id={id}
      readOnly={readOnly}
      widgetKey={widgetKey}
      loadWidgetData={loadWidgetData}
      file={widgetPaths['risk_model_specific_risk_distribution']}
      fullScreen={fullScreen}
      title={title}
    />
  );

  return <>{mode == 'edit' ? <Form params={params} setParams={setParams} /> : renderJobComponent()}</>;
};

export default SpecificRiskDistribution;
